<template>
    <div>
        <limitless-page-header :title="'Bildbank'" sub-title="kategorier">
            <template #header-elements>
                <limitless-page-header-button :route="{ name: 'mediabank.category', params: { id: 0 } }" icon="icon-plus3">Ny kategori</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <rednax-datatable :url="'/vue/mediabank/categories'" :columns="table_columns" :filter="table_filter" @updateFilter="table_filter=$event" sort-by="CatName" sort-order="asc" @rowclick="rowClick" history>
                <div class="row">
                    <div class="col-lg-3">
                        <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                    </div>
                </div>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';

export default {
    name: 'MediabankCategoryList',
    components: {
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        RednaxDatatable,
    },
    data: () => ({
        table_filter: {
            search: '',
            per_page: 25,
        },
        table_columns: [
            {
                header: '#',
                data: 'CatID',
                sortable: true,
            },
            {
                header: 'Namn',
                data: 'CatName',
                sortable: true,
            },
            {
                header: 'Antal bilder',
                data: 'images_count',
                sortable: false,
            },
        ],
    }),
    methods: {
        rowClick(row, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                window.open('/mediabank/categories/' + row.CatID).focus();
            } else {
                this.$router.push({ name: 'mediabank.category', params: { id: row.CatID } });
            }
        },
    },
};

</script>
